/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Story_EyebrowInputs */

const vi_shop_home_story_eyebrow = /** @type {(inputs: Shop_Home_Story_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng nhỏ trên tiêu đề`)
};

/**

* @param {Shop_Home_Story_EyebrowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_story_eyebrow = /** @type {((inputs?: Shop_Home_Story_EyebrowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Story_EyebrowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_story_eyebrow(inputs)
});